import { createContext, useContext } from 'react';

/**
 * Leaving the auth frame for the dashboard (the session just opened): the 3D
 * panel slides off to the right like a closing modal and the form column
 * fades; the route changes once that is over.
 */
export const AUTH_EXIT_MS = 800;

/** Forward steps slide in from the right, going back from the left. */
export function authSlideDirection(pathname: string): 1 | -1 {
  return pathname === '/create-account' || pathname === '/login/success'
    ? 1
    : -1;
}

export type LeaveAuth = (to: string) => void;

export const AuthExitContext = createContext<LeaveAuth | null>(null);

/** Set by AuthRouteTransition; every auth route renders inside it. */
export function useLeaveAuth(): LeaveAuth {
  const leave = useContext(AuthExitContext);
  if (!leave) {
    throw new Error('useLeaveAuth must be used inside AuthRouteTransition');
  }
  return leave;
}
